// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c70af0a","952":"878497bb"}[chunkId] + ".chunk.js";
};